export const QUEUE_NOTIFICATION = 'QUEUE_NOTIFICATION';
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
export const DISMISS_NOTIFICATIONS_BUNDLE = 'DISMISS_NOTIFICATIONS_BUNDLE';
export const DISMISS_TOPIC_NOTIFICATIONS = 'DISMISS_TOPIC_NOTIFICATIONS';
